import React from 'react';
import {Intent, Spinner} from '@blueprintjs/core';

import {SimpleSelect} from '../../../select';

type Callback = (value?: any) => void;

interface SelectConnectionProps {
  show: boolean;
  selected: string;
  onSelect: Callback;
  label?: string;
  options?: any;
  disabled?: boolean;
}

const SelectConnection = ({
  show,
  selected,
  onSelect,
  options,
  label = 'Select Connection',
  disabled = undefined,
}: SelectConnectionProps) => {
  if (!show) {
    return null;
  }

  if (!(options as any)?.length) {
    return <Spinner size={16} />;
  }

  return (
    <SimpleSelect
      selected={selected}
      onChange={onSelect}
      options={options || []}
      disabled={disabled !== undefined ? disabled : false}
      buttonProps={{
        minimal: true,
        small: true,
        intent: !selected ? Intent.WARNING : undefined,
      }}
      selectDefault={false}
      label={label}
      popoverProps={{
        usePortal: true,
      }}
    />
  )
};

export default SelectConnection;
